export default {
  navigationBarTitleText: '选择城市'
}
